import React from 'react';
import SimpleLayout from '../components/SimpleLayout';
import SurveyTypeSelection from '../components/surveys/SurveyTypeSelection';

const CreateSurvey = () => {
  return (
    <SimpleLayout title="Create New Survey" backTo="/dashboard">
      <SurveyTypeSelection />
    </SimpleLayout>
  );
};

export default CreateSurvey;
